import React, { useState } from "react";
import "../css/LoginPage.css";
import Footer from "./Footer";
import ProfileNavBar from "./ProfileNavBar";
import { Link } from "react-router-dom";
import "../css/BmiCalculator.css";
import { useEffect } from "react";
import UserFooter from "./UserFooter";
import ChatComponent from "./ChatComponent";
import JsonFormatter from "./JsonFormatter";

const BMICalculatorPage = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const [userPlanID, setUserPlanID] = useState(null);
  if (!user) {
    window.location.href = "/login";
  }

  const [bmiResult, setBmiResult] = useState(null);
  const [bmiInsights, setBmiInsights] = useState(null);

  const getBMIStatus = (bmi) => {
    if (bmi < 18.5) return "Underweight";
    if (bmi < 25) return "Fit";
    if (bmi < 30) return "Overweight";
    return "Obese";
  };

  useEffect(() => {
    fetch("https://18.117.231.157/api/getuserplan", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userID: user.userID }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log("User plan:", data.plan);
          setUserPlanID(data.plan);
        } else {
          console.error("Failed to fetch user plan:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching user plan:", error);
      });
  }, [user.userID]);

  const planDetails = {
    Underweight: {
      "3-Months Plan – Aggressive Gain Plan": [
        "Active Days: 6/week | Rest Days: 1/week",
        "Strength Workout: 4x/week (60–75 mins)",
        "Walking: Daily (20–30 mins)",
        "Cycling: 1x/week (30 mins light ride)",
        "Running: 1x/week (15 mins slow jog)",
        "Yoga: 1x/week (30 mins)",
        "Meditation: 3x/week (10–15 mins)",
        "Swimming: Optional (30 mins every 2 weeks)",
      ],
      "6-Months Plan – Balanced & Sustainable": [
        "Active Days: 5/week | Rest Days: 2/week",
        "Strength Workout: 3–4x/week (50–60 mins)",
        "Walking: Daily (20–25 mins)",
        "Cycling: 1x/week (30 mins)",
        "Running: 1x/week (15–20 mins intervals)",
        "Yoga: Weekly (30–45 mins)",
        "Meditation: 3x/week (10–15 mins)",
        "Swimming: Bi-weekly (30 mins)",
      ],
      "12-Months Plan – Lifestyle Transformation": [
        "Active Days: 5–6/week | Rest Days: 1–2/week",
        "Strength Workout: 3x/week (45–60 mins)",
        "Walking: Daily (30 mins brisk walk)",
        "Cycling: Weekly (45 mins)",
        "Running: Weekly (20–25 mins)",
        "Yoga: Weekly (45 mins)",
        "Meditation: Optional daily (10–20 mins)",
        "Swimming: Monthly (45 mins)",
      ],
      "No Time Limit – Lifelong Routine": [
        "Focus: Health maintenance and enjoyment",
        "Strength Workout: 2–3x/week (45–60 mins)",
        "Walking: Daily (30 mins or 7–10k steps)",
        "Cycling: Weekly (30–45 mins)",
        "Running: Weekly (15–20 mins easy pace)",
        "Yoga: 2x/week (30–45 mins)",
        "Meditation: Daily (10–15 mins)",
        "Swimming: Optional (30–60 mins/month)",
      ],
    },
    Fit: {
      "3-Months Plan – Performance Focus": [
        "Active Days: 6/week | Rest Days: 1/week",
        "Strength Workout: 4x/week (60 mins, Upper/Lower splits)",
        "Walking: Daily (20–30 mins)",
        "Cycling: Weekly (30–45 mins)",
        "Running: 1–2x/week (20 mins moderate)",
        "Yoga: 1x/week (45 mins)",
        "Meditation: 2–3x/week (10–15 mins)",
        "Swimming: Optional (30 mins bi-weekly)",
      ],
      "6-Months Plan – Lean Muscle & Recovery Balance": [
        "Active Days: 5–6/week | Rest Days: 1–2/week",
        "Strength Workout: 3–4x/week (50–60 mins, Push-Pull-Legs)",
        "Walking: Daily (25–30 mins)",
        "Cycling: Weekly (45 mins)",
        "Running: Weekly (20–30 mins intervals)",
        "Yoga: Weekly (45 mins)",
        "Meditation: 3x/week (10–20 mins)",
        "Swimming: Bi-weekly (30 mins)",
      ],
      "12-Months Plan – Optimized Fitness Lifestyle": [
        "Sleep: Daily 7–9 hours",
        "Strength Workout: 3x/week (Functional + strength)",
        "Walking: Daily (30–45 mins)",
        "Cycling: Weekly (60 mins)",
        "Running: Weekly (30 mins)",
        "Yoga: Weekly (60 mins mobility)",
        "Meditation: 4x/week (15 mins)",
        "Swimming: Monthly (45–60 mins)",
      ],
      "No Time Limit Plan – Holistic Maintenance": [
        "Focus: Joyful movement and emotional resilience",
        "Strength Workout: 2–3x/week (45–60 mins)",
        "Walking: Daily (45 mins or 7–10k steps)",
        "Cycling: Weekly (45 mins)",
        "Running: Optional (15–20 mins)",
        "Yoga: 2x/week (30–45 mins)",
        "Meditation: Daily (10–20 mins)",
        "Swimming: Optional monthly (30–60 mins)",
      ],
    },
    Overweight: {
      "3-Months Plan – Jumpstart & Foundation": [
        "Active Days: 5/week | Rest Days: 2/week",
        "Workout: 4x/week (30–45 mins)",
        "Walking: Daily (15–30 mins)",
        "Cycling: 1x/week (20 mins)",
        "Running: 1x/week (15 mins slow jog)",
        "Yoga: 1x/week (30 mins)",
        "Meditation: 3x/week (10–15 mins)",
        "Swimming: Optional (30 mins bi-weekly)",
      ],
      "6-Months Plan – Fat Loss & Muscle Activation": [
        "Active Days: 5/week | Rest Days: 2/week",
        "Workout: 4x/week (45 mins)",
        "Walking: Daily (30 mins)",
        "Cycling: Weekly (30–45 mins)",
        "Running: Weekly (20 mins intervals)",
        "Yoga: Weekly (30–45 mins)",
        "Meditation: 3x/week (10–15 mins)",
        "Swimming: Bi-weekly (30 mins)",
      ],
      "12-Months Plan – Sustainable Stamina Building": [
        "Workout: 3–4x/week (45–60 mins)",
        "Walking: Daily (30–45 mins)",
        "Cycling: Weekly (45 mins)",
        "Running: Weekly (25 mins)",
        "Yoga: Weekly (45 mins)",
        "Meditation: Optional (15 mins daily)",
        "Swimming: Monthly (45 mins)",
      ],
      "No Time Limit Plan – Health Maintenance": [
        "Workout: 2–3x/week (30–45 mins)",
        "Walking: Daily (30–60 mins)",
        "Cycling: Weekly (30 mins)",
        "Yoga: Weekly (30–45 mins)",
        "Meditation: Daily (10–15 mins)",
        "Swimming: Optional (30 mins monthly)",
      ],
    },
    Obese: {
      "3-Months Plan – Build Confidence & Mobility": [
        "Workout: 3x/week (20–30 mins chair or water based)",
        "Walking: Daily (10–15 mins)",
        "Cycling: 1x/week (light effort)",
        "Yoga: 1x/week (chair yoga or restorative)",
        "Meditation: 3x/week (10 mins)",
        "Swimming: Optional (light aquatic therapy)",
      ],
      "6-Months Plan – Mobility + Light Strength": [
        "Workout: 3–4x/week (30–45 mins low impact)",
        "Walking: Daily (15–20 mins)",
        "Cycling: Weekly (20–30 mins)",
        "Yoga: Weekly (gentle/breathing focus)",
        "Meditation: Daily (10–15 mins)",
        "Swimming: Bi-weekly (30 mins)",
      ],
      "12-Months Plan – Consistent & Empowering": [
        "Workout: 3x/week (45 mins progressive)",
        "Walking: Daily (20–30 mins)",
        "Cycling: Weekly (30–45 mins)",
        "Yoga: Weekly (45 mins mobility)",
        "Meditation: Daily (15 mins)",
        "Swimming: Monthly (45 mins)",
      ],
      "No Time Limit Plan – Lifelong Health & Joy": [
        "Workout: 2x/week (30–45 mins)",
        "Walking: Daily (30 mins)",
        "Yoga: Weekly (30–45 mins)",
        "Meditation: Daily (10–20 mins)",
        "Swimming: Optional (30–60 mins/month)",
      ],
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const weight = parseFloat(e.target.weight.value);
    const weightUnit = e.target.weightUnit.value;
    const height = parseFloat(e.target.height.value);
    const heightUnit = e.target.heightUnit.value;

    if (!weight || !height || !weightUnit || !heightUnit) {
      alert("Please fill in all fields correctly.");
      return;
    }

    const weightKg = weightUnit === "lbs" ? weight * 0.453592 : weight;

    let heightM;
    if (heightUnit === "cm") heightM = height / 100;
    else if (heightUnit === "inches") heightM = height * 0.0254;
    else if (heightUnit === "feet") heightM = height * 0.3048;

    const bmi = (weightKg / (heightM * heightM)).toFixed(2);
    setBmiResult(bmi);

    const userDetails = {
      height: height,
      heightUnit: heightUnit,
      weight: weight,
      weightUnit: weightUnit,
      age: e.target.age.value,
      bmi: bmi,
    };

    fetch("https://18.117.231.157/api/bmiInsights", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userDetails: userDetails }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log("Insights:", data.bmiInsights);
          setBmiInsights(data.bmiInsights);
        } else {
          console.error("Failed to fetch insights:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching insights:", error);
      });
  };

  const planIdMap = {
    Underweight: ["u1", "u2", "u3", "u4"],
    Fit: ["f1", "f2", "f3", "f4"],
    Overweight: ["w1", "w2", "w3", "w4"],
    Obese: ["o1", "o2", "o3", "o4"],
  };

  const handlePlanSelect = async (planCategory, index) => {
    const planID = planIdMap[planCategory][index];
    console.log("Selected Plan ID:", planID);
    const planTitle = Object.keys(planDetails[planCategory])[index];

    let proceed = true;

    if (userPlanID) {
      proceed = window.confirm(
        "You already have a selected plan. Would you like to change it?"
      );
    } else {
      proceed = window.confirm(
        `Are you sure you want to select the "${planTitle}" plan?`
      );
    }

    if (!proceed) return;

    try {
      const res = await fetch("https://18.117.231.157/api/setplan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userID: user.userID, planID }),
      });

      const data = await res.json();
      if (data.success) {
        alert(`Plan ${planID} has been successfully set.`);
        setUserPlanID(planID);
      } else {
        alert("Failed to set plan. Please try again.");
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while setting the plan.");
    }
  };
  return (
    <div>
      <ProfileNavBar />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h1 className="contactuspageheaders">BMI Calculator</h1>
      <form className="loginform" onSubmit={handleSubmit}>
        <label htmlFor="weight">Weight</label>
        <div className="rowtype">
          <input
            type="number"
            step="0.01"
            id="weight"
            name="weight"
            required
            placeholder="Weight in lbs or kg"
            min="1"
          />
          <select id="weightUnit" name="weightUnit" required>
            <option value="">Select Units</option>
            <option value="lbs">lbs</option>
            <option value="kg">kgs</option>
          </select>
        </div>

        <label htmlFor="height">Height</label>
        <div className="rowtype">
          <input
            type="number"
            step="0.01"
            id="height"
            name="height"
            required
            placeholder="Height in feet/inches/cm"
            min="1"
          />
          <select id="heightUnit" name="heightUnit" required>
            <option value="">Select Units</option>
            <option value="feet">feet</option>
            <option value="inches">inches</option>
            <option value="cm">cm</option>
          </select>
        </div>

        <label htmlFor="age">Age</label>
        <input
          type="number"
          id="age"
          name="age"
          required
          placeholder="Age in years"
          min="1"
        />

        <button type="submit" className="loginbutton">
          Calculate BMI
        </button>
      </form>

      {bmiInsights && <JsonFormatter data={bmiInsights} />}

      {bmiResult && (
        <div
          className="loginform"
          style={{ marginTop: "20px", textAlign: "center" }}
        >
          <h2 className="contactuspageheaders">Here are your results</h2>
          <h3>
            Your BMI is: {bmiResult} - {getBMIStatus(bmiResult)}
          </h3>
          <h3 style={{ marginTop: "10px", fontWeight: "bold" }}>
            Based on your analysis we have some recommended plans,{" "}
          </h3>
          <div className="rowtype">
            {Object.entries(planDetails[getBMIStatus(bmiResult)]).map(
              ([title, activities], i) => (
                <div
                  key={i}
                  style={{
                    marginBottom: "15px",
                    textAlign: "left",
                    maxWidth: "500px",
                    marginInline: "auto",
                  }}
                >
                  <div className="planTile">
                    <h4>{title}</h4>
                    <ul style={{ paddingLeft: "20px" }}>
                      {activities.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                    <button
                      type="submit"
                      className="planbutton"
                      onClick={() =>
                        handlePlanSelect(getBMIStatus(bmiResult), i)
                      }
                    >
                      {userPlanID ? "Change Plan" : "Select Plan"}
                    </button>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      )}
      <br />
      <br />
      <br />
      <br />
      <ChatComponent />
      <UserFooter />
      <Footer />
    </div>
  );
};

export default BMICalculatorPage;
